import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import DashboardView from './views/DashboardView';
import PipelineView from './views/PipelineView';
import AnalyticsView from './views/AnalyticsView';
import SettingsView from './views/SettingsView';
import DemoView from './views/DemoView';
import './index.css';

function App() {
  const [activeView, setActiveView] = useState('dashboard');

  const renderView = () => {
    switch (activeView) {
      case 'dashboard': return <DashboardView />;
      case 'pipeline': return <PipelineView />;
      case 'analytics': return <AnalyticsView />;
      case 'demo': return <DemoView />;
      case 'settings': return <SettingsView />;
      default: return <DashboardView />;
    }
  };

  return (
    <div className="flex h-screen bg-slate-950 text-slate-200 font-sans overflow-hidden selection:bg-blue-500/30">
      <Sidebar activeView={activeView} setActiveView={setActiveView} />
      
      <div className="flex-1 flex flex-col h-full overflow-hidden relative">
        {/* Ambient background glows */}
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] bg-blue-900/10 rounded-full blur-[120px] pointer-events-none"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] bg-green-900/10 rounded-full blur-[120px] pointer-events-none"></div>
        
        <TopBar />
        
        <main className="flex-1 overflow-y-auto relative z-10 custom-scrollbar">
          {renderView()}
        </main>
      </div>
    </div>
  );
}

export default App;